import React from 'react';
import styled from 'styled-components';
import { CTALink } from '../Link';
import { RichTextWithAnchor } from '../Typography/RichText';
import media from '../../utils/media';
import { isFieldValid, isValidType } from '../../utils/validation';
const Container = styled.div `
  width: 100%;
  background-color: ${({ theme }) => theme.primaryWhite};
  position: relative;

  ${media.mobile} {
    margin-bottom: 30px;
  }

  ${media.mobileL} {
    margin: 0 15px;
    width: calc(100% - 30px);
  }
`;
const RichTextContainer = styled.div `
  margin-bottom: 20px;
`;
export const InfoGraphicsText = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const { ctaLink, ctaLinkText, ctaType, textBoxBodyText } = fields;
    return (React.createElement(Container, null,
        isFieldValid(textBoxBodyText) && isValidType(textBoxBodyText, 'string') && (React.createElement(RichTextContainer, null,
            React.createElement(RichTextWithAnchor, { field: textBoxBodyText }))),
        isFieldValid(ctaLink, 'href') && isFieldValid(ctaLinkText) && (React.createElement(CTALink, { field: ctaLink, textField: ctaLinkText, typeField: ctaType }))));
};
